import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { PageHeader } from "@/components/Shared";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function EmailTemplate() {
  const [t, setT] = useState(null);
  const [testing, setTesting] = useState(false);
  useEffect(() => { api.get("/email-template").then((r) => setT(r.data)); }, []);
  if (!t) return <div className="text-slate-500">Caricamento…</div>;

  const save = async () => {
    try { await api.put("/email-template", { subject: t.subject, body: t.body }); toast.success("Modello salvato"); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };
  const sendTest = async () => {
    setTesting(true);
    try {
      const { data } = await api.post("/email-test");
      if (data.status === "inviata") toast.success(`E-mail di prova inviata a ${data.to}`);
      else if (data.status === "simulata") toast.info("Modalità simulazione: e-mail registrata ma non inviata");
      else toast.error(data.error || "Invio non riuscito");
    } catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
    setTesting(false);
  };

  return (
    <div>
      <PageHeader title="Modello E-mail" subtitle="Personalizza il riepilogo inviato ai partecipanti. Le risposte dei partecipanti arrivano a segreteria@centrostudiathena.it." />
      <div className="grid lg:grid-cols-2 gap-6">
        <Card className="p-6 border-slate-200 space-y-4">
          <div><Label>Oggetto</Label><Input value={t.subject} onChange={(e) => setT({ ...t, subject: e.target.value })} data-testid="tmpl-subject" /></div>
          <div><Label>Corpo</Label><Textarea rows={16} value={t.body} onChange={(e) => setT({ ...t, body: e.target.value })} className="font-mono text-xs" data-testid="tmpl-body" /></div>
          <Button onClick={save} data-testid="save-template-btn" className="bg-[#0B192C] hover:bg-[#07111E]">Salva modello</Button>
          <div className="border-t border-slate-200 pt-4">
            <Label>Invia un'e-mail di prova</Label>
            <p className="text-xs text-slate-500 mt-1">La prova viene inviata all'indirizzo del tuo account.</p>
            <Button variant="outline" className="mt-2" onClick={sendTest} disabled={testing} data-testid="email-test-btn">{testing ? "Invio…" : "Invia prova al mio indirizzo"}</Button>
          </div>
        </Card>
        <Card className="p-6 border-slate-200">
          <h3 className="font-display font-bold text-slate-900 mb-2">Segnaposto disponibili</h3>
          <p className="text-sm text-slate-500 mb-3">Usa queste variabili nel testo tra parentesi graffe:</p>
          <div className="grid grid-cols-2 gap-2 text-xs font-mono text-slate-600">
            {["first_name","last_name","course_title","lesson_number","lesson_date","lesson_minutes","last_status","last_presence_min","last_absence_min","last_accessi","total_hours","presence_hours","absence_hours","absence_pct","max_absence","personal_link"].map((v) => (
              <span key={v} className="bg-slate-100 rounded px-2 py-1">{`{${v}}`}</span>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
